// client/src/utils/subjectLabel.generated.js
//
// GENERATED - do not edit by hand.
//
// Copied from packages/core/src/ui/labels.js by tools/sync-shared.py. Edit the core file and re-run that
// script; `node tools/marks-sheet-conformance.mjs` asserts this copy has not
// drifted from it.
//
// The phone imports the original. The web cannot (packages/core is outside
// client/src, and the CRA build will not resolve it), so it gets this. They must
// stay identical - a rule that exists twice and differs is the whole class of
// bug these files were written to end.
//
// How a subject is named where a full name will not fit. Both clients
// must abbreviate identically, or the same chart reads differently on a
// phone and on a laptop.

/**
 * A SUBJECT, SHORT ENOUGH FOR A CHART AXIS.
 *
 * "Further Mathematics" and "Physical Education" cannot sit beside each other
 * under a bar chart on a phone: the labels overlap, or the renderer tilts them,
 * or it truncates at whatever width it happens to have and the reader gets
 * "Furth…" and "Physi…" — which is worse than an abbreviation because it is
 * inconsistent and looks like a fault rather than a decision.
 *
 * THE SCHOOL HAS ALREADY DECIDED THIS. `Subject.code` is what the add form calls
 * CLIPPED FORM and requires on every subject — MATH for Mathematics, whatever
 * that school actually writes on a timetable. Using it means the chart speaks the
 * language of the people reading it, and nothing here has to guess.
 *
 * The fallback is for rows created before Clipped Form was required, and it
 * abbreviates the way people do rather than by cutting a string:
 *
 *   several words   the initials — Physical Education -> PE
 *   one word        the first four letters — Biology -> BIOL
 *
 * Cutting at N characters would give "PHYSI" and "BIOLO", which read as damage.
 * Initials and a four-letter stem read as shorthand.
 *
 * @param {string} name  the subject's full name
 * @param {string} [code] its clipped form, if the school recorded one
 * @returns {string}
 */
export function subjectChartLabel(name, code) {
  const clipped = String(code || '').trim();
  if (clipped) return clipped.toUpperCase();

  const full = String(name || '').trim();
  if (!full) return '—';

  // Words that carry no meaning in an abbreviation. "History of Art" is HA, not
  // HOA — the joining word is not what distinguishes it from anything.
  const SKIP = new Set(['of', 'and', 'the', 'de', 'du', 'des', 'la', 'le', 'les', 'et', '&']);
  const words = full.split(/[\s/_-]+/).filter(Boolean);
  const meaningful = words.filter((w) => !SKIP.has(w.toLowerCase()));

  if (meaningful.length > 1) {
    return meaningful.map((w) => w[0]).join('').toUpperCase().slice(0, 5);
  }
  return (meaningful[0] || full).slice(0, 4).toUpperCase();
}
